var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-icon"},[(_vm.path)?_c('img',{staticClass:"title-icon__icon",attrs:{"src":_vm.path,"alt":_vm.alt}}):_vm._e(),_vm._v("\n  "+_vm._s(this.Icon.Title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }